exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?minimize!../assets/zw-icon/zw-iconfont.css"), "");

// module
exports.push([module.id, ".zw-toolbar-wraper[data-v-f499876c]{width:100%;height:2.5rem;line-height:2.5rem;position:absolute;z-index:100;margin-top:.625rem;top:1.5rem;text-align:right;right:1rem}.zw-toolbar-btn[data-v-f499876c]{width:2rem;height:2rem;line-height:2rem;text-align:center;display:inline-block;border:.0625rem solid #0089ff;border-radius:50%;background-color:#0089ff;color:#fff;cursor:pointer;margin:0 .125rem 0 0}.zw-toolbar-btn[data-v-f499876c]:hover{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f499876c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/zw-toolbar.vue
// module id = 1121
// module chunks = 45